module.exports = __webpack_public_path__ + "static/media/tramite-express-logo-green.1ae1cfb5.svg";